import { render } from "./AuthorsComponent.vue?vue&type=template&id=40448c4f&scoped=true"
import script from "./AuthorsComponent.vue?vue&type=script&lang=js"
export * from "./AuthorsComponent.vue?vue&type=script&lang=js"

import "./AuthorsComponent.vue?vue&type=style&index=0&id=40448c4f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40448c4f"]])

export default __exports__